import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Hero.css';

function Hero() {
  return (
    <section id="home" className="hero-section">
      <Container>
        <Row className="align-items-center min-vh-100">
          <Col lg={6} className="hero-content" data-aos="fade-right">
            <div className="hero-badges">
              <span className="badge-custom">
                <i className="fab fa-apple"></i> iOS 17.6+
              </span>
              <span className="badge-custom">
                <i className="fas fa-clock"></i> watchOS 10.6+
              </span>
              <span className="badge-custom">
                <i className="fas fa-medal"></i> Apple Watch Ultra Ready
              </span>
            </div>
            <h1>Enhance Your Diving Experience with Advanced Dive Analysis</h1>
            <p>
              Experience the most comprehensive dive logging and analysis for iOS and watchOS.
              Detailed dive tracking, post-dive analysis, and comprehensive analytics
              to enhance your diving experience.
            </p>
            <div className="hero-buttons">
              <a 
                href="https://apps.apple.com/us/app/zdive/id6742788878" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn-primary-custom app-store-btn"
                aria-label="Download ZDIVE on the App Store"
              >
                <img 
                  src={`${process.env.PUBLIC_URL}/download-on-appstore.svg`} 
                  alt="Download ZDIVE on the App Store" 
                  className="hero-app-store-badge"
                />
              </a>
              {/* <a href="#ios-gallery" className="btn-outline-custom">
                Learn More
              </a> */}
            </div>
          </Col>
          <Col lg={6} className="text-center" data-aos="fade-left">
            <div className="device-mockup">
              <img 
                src={`${process.env.PUBLIC_URL}/wosBoth.png`}
                alt="Apple Watch ZDIVE App Interface"
                className="mockup-image"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Hero;